export default {
  INIT: "INIT",
  BUNDLE: "BUNDLE",
  ASSETS: "ASSETS",
  FETCH: "FETCH",
};
